<template>
  <div class="policyList_container">
     <div class="box-contentposition">
        <div class="back" @click="backHome">
          <i class="el-icon-s-platform"></i>
          首页
        </div>
        当前位置： 目录 > {{title}}
    </div>
    <div class="newsNoticeContent">
      <navigationList
        :list="menuList"
        :type="'栏目导航'"
        @navItem="navItem"
        :switchTypeindex="switchTypeindex"
      >
      </navigationList>
      <div class="list_container">
        <div class="content">
          <!-- 标题 -->
          <div class="title">
            <span>{{title}}</span>
          </div>
          <!-- 列表 -->
          <div class="tablelist">
            <div
              v-for="(item,index) in articleList"
              @click="goToDetail(item)"
            >
              <div class="item">
                <!-- <div class="icon"></div> -->
                <div class="title">{{item.titile}}</div>
                <div class="date">{{item.date}}</div>
              </div>
              <!-- <div
                class="split"
                v-if="index==4"
              ></div> -->
            </div>
          </div>
          <!-- 分页 -->
          <el-row class="pagination">
            <el-pagination
              small
              background
              :current-page="page"
              :page-size="pageSize"
              layout="prev, pager, next"
              :total="total"
              @current-change="pageChangeHandler"
              class="mt-4"
            />
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Cookies from "js-cookie"
  import API from "@/api/bigScreen/api_big_screen";
  import navigationList from "./components/navigationList.vue";
  export default {
    components: {
      navigationList,
    },
    data() {
      return {
        menuList: [
          {
            id: "10611001",
            name: "政策法规",
          },
          {
            id: "10611003",
            name: "通知公告",
          },
          {
            id: "10611002",
            name: "时事要闻",
          },
        ],
        qhdm: Cookies.get('curAreaCode'),
        switchTypeindex: 0,
        currentIndexId: "10611001",
        title: "政策法规",
        page: 1,
        pageSize: 10,
        articleList: [],
        total: 0,
      };
    },
    created() {
      if(this.$route.query.category){
        this.currentIndexId = this.$route.query.category;
        this.switchTypeindex = this.menuList.findIndex(item => {
          return item.id === this.currentIndexId;
        })
       this.title = this.menuList[this.switchTypeindex].name
      }

      this.getData();
    },
    methods: {
      backHome() {
        this.$router.push({ path: "/homepage/home" })
      },

      // 点击侧导航
      navItem(name, index, id) {
        location.hash="#/policy/policyList?category="+id;
        this.switchTypeindex = index;
        this.currentIndexId = id;
        this.title = name;
        this.getData();
      },
      async getData() {
        let params = {
          qhdm: this.qhdm,
          // category: (this.currentIndexId=='2'||this.currentIndexId=='7') ? "1" : "2",
          page: this.page,
          typeDicNumber: this.currentIndexId,
        };
        let { code, data } = await API.policyNews(params);
        if (code == 0) {
          data.list.forEach((item) => {
            item.date = this.intToDate(item.pulishTime);
          });
          this.articleList = data.list;
          this.total = data.total;
        }
      },
      intToDate(number) {
        let str = "--";
        if (number) {
          let dateStr = number + "";
          let year = dateStr.substring(0, 4);
          let month = dateStr.substring(4, 6);
          let day = dateStr.substring(6);
          str = year + "-" + month + "-" + day;
        }
        return str;
      },
      pageChangeHandler(val) {
        this.page = val;
        this.getData();
      },
      goToDetail(item) {
        this.currentItem = { ...item };
        let path = "/policy/article"
        this.$router.push({
          path: path,
          query: {
            id: item.number,
            title: this.title,
            tabId: this.currentIndexId
          },
        });
      },
    },
  };
</script>

<style lang="less">
  .box-contentposition{
    padding-bottom: 20px;
    display: flex;
    align-items: center;
  }

  .back {
    width: 55px;
    padding: 4px 8px;
    border: 1px solid #00D7FE;
    border-radius: 20px;
    cursor: pointer;
    margin-right: 16px;
  }

  .policyList_container {
    width: 1200px;
    margin: 0 auto;
    padding: 30px 0 ;
    height: calc(100% - 60px - 42px);
    .newsNoticeContent {
      display: flex;
      min-height: calc(100vh - 390px);
      height: 100%;
      .newsNoticeLeft {
        width: 226px;
        box-shadow: 1px 1px 10px #ddd;
        background: #ffffff;
        //   border-top: 5px solid #09589c;
        .newsNoticeLeftTitle {
          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          // color:#0e932e ;
          color: #000000;
          // background-color: rgba(0, 149, 91, 1);
          height: 70px;
          line-height: 70px;
          text-align: center;
          border-bottom: 1px solid #eef0f3;
          img {
            width: 40px;
            height: 40px;
            vertical-align: middle;
          }
        }
        .newsNoticeLeftBtnGrounp {
          // margin-top: 30px;
          display: flex;
          flex-direction: column;
          .navig_list {
            width: 200px;
            height: 100%;
            margin: 0 auto;
            .button_name {
              border-width: 0px;
              width: 200px;
              height: 47px;
              background: inherit;
              background-color: rgba(242, 242, 242, 1);
              border: none;
              border-radius: 0px;
              display: flex;
              justify-content: space-around;
              color: #333333;
              font-family: Source Han Sans CN;
              line-height: 47px;
              margin-top: 15px;
            }
            .tabBtnActive {
              border-width: 0px;
              width: 200px;
              height: 47px;
              background: inherit;
              background-color: #02A7F0;
              border: none;
              border-radius: 0px;
              display: flex;
              justify-content: space-around;
              color: #ffff;
              font-family: Source Han Sans CN;
              line-height: 47px;
              margin-top: 15px;
            }
          }
        }
      }
      .list_container {
        flex: 1;
        background: #ffffff;
        margin-left: 20px;
        border-radius: 5px;
        padding-left: 10px;
        padding-right: 10px;
        .content {
          width: 100%;
          height: 100%;
          background: #fff;
          padding: 0 10px;
          box-sizing: border-box;
          overflow: hidden;
          .title {
            width: 100%;
            height: 70px;
            border-bottom: #02A7F0 solid 1px;
            padding-top: 20px;
            box-sizing: border-box;
            img {
              width: 35px;
              height: 35px;
              vertical-align: middle;
              margin-left: 20px;
            }
            span {
              font-family: "Arial Negreta", "Arial Normal", "Arial", sans-serif;
              font-weight: 700;
              font-style: normal;
              font-size: 18px;
              color: #000000;
              margin-left: 20px;
            }
          }
          .tablelist {
            height: calc(100% - 120px);
            width: 100%;
            overflow-y: auto;
            padding: 20px;
            box-sizing: border-box;
            .split {
              width: 100%;
              height: 30px;
            }
            .item {
              width: 100%;
              height: 55px;
              // display: flex;
              line-height: 55px;
              cursor: pointer;
              font-size: 0;
              color: #333;
              border-bottom: 1px solid #eef0f3;
              &:hover {
                color: #02A7F0;
                border-bottom: 1px solid #02A7F0;
              }
              .icon {
                height: 100%;
                width: 24px;
                background-size: 12px 12px;
                background-position: center;
                background-repeat: no-repeat;
                // background-image: url("../../../static/img/li.png");
              }
              .icon,
              .title,
              .date {
                display: inline-block;
                height: 100%;
                vertical-align: middle;
                font-size: 16px;
              }
              .title {
                width: calc(100% - 130px);
                //超出一行省略号
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                padding: 0 4px;
                box-sizing: border-box;
                border: none;
              }
              .date {
                display: inline-block;
                width: 110px;
                text-align: center;
                color: #666;
              }
            }
          }
          .pagination {
            display: flex;
            justify-content: center;
            height: 50px;
            .el-pagination.is-background .el-pager li:not(.disabled).active {
              background-color: #02A7F0 !important;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/studio/policy/main.vue